import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Textarea,
  useDisclosure,
} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCurrentUserQuery } from "modules/tenant/queries/use-current-user-query";
import { useState } from "react";
import { apiRequest } from "utils/api";

const SaveFilterButton = ({ filters }: { filters: any }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { refetch } = useCurrentUserQuery();

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [saving, setSaving] = useState(false);

  const saveFilter = async () => {
    setSaving(true);

    try {
      await apiRequest("/supabase/saved_filters/insert", {
        title,
        description,
        filters: JSON.stringify(filters),
      });
      await refetch();
      onClose();
    } catch (err) {
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box flex="1">
      <Button
        onClick={onOpen}
        aria-label="save-filter"
        variant="outline"
        w="100%"
        leftIcon={<FontAwesomeIcon icon={["far", "floppy-disk"]} />}
      >
        Save
      </Button>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Save Filter</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl mb="20px">
              <FormLabel mb="0px">Filter Name</FormLabel>
              <Input
                placeholder="Large Multi-Family"
                value={title}
                variant="primary"
                onChange={ev => setTitle(ev.target.value)}
              />
            </FormControl>
            <FormControl>
              <FormLabel mb="0px">Filter Description</FormLabel>
              <Textarea
                placeholder="Some additional information about this filter..."
                variant="primary"
                value={description}
                onChange={ev => setDescription(ev.target.value)}
              />
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onClose}>
              Cancel
            </Button>
            <Button onClick={saveFilter} isLoading={saving}>
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default SaveFilterButton;
